import React from "react";

const HistoryPage = () => {
  return (
    <div
      style={{
        height: "100%",
        background: "#f5f6fa",
        overflow: "auto",
        padding: "20px",
      }}
    >
      {/* Header Section */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: 4,
          padding: "20px",
          marginBottom: "16px",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "24px",
            fontWeight: 600,
            color: "#1a2540",
          }}
        >
          History
        </h2>

        <div
          style={{
            display: "flex",
            gap: "12px",
            marginTop: "16px",
            flexWrap: "wrap",
          }}
        >
          <input
            placeholder="Search Device"
            style={{
              height: "36px",
              padding: "0 12px",
              border: "1px solid #d8dde8",
              borderRadius: "4px",
              minWidth: "220px",
            }}
          />

          <input
            type="date"
            style={{
              height: "36px",
              padding: "0 12px",
              border: "1px solid #d8dde8",
              borderRadius: "4px",
            }}
          />

          <input
            type="date"
            style={{
              height: "36px",
              padding: "0 12px",
              border: "1px solid #d8dde8",
              borderRadius: "4px",
            }}
          />

          <button
            style={{
              height: "36px",
              padding: "0 20px",
              background: "#082D6B",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Search
          </button>
        </div>
      </div>

      {/* Data Section */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "4px",
          height: "calc(100vh - 230px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#8b93a5",
          fontSize: "18px",
        }}
      >
        No History Data Found
      </div>
    </div>
  );
};

export default HistoryPage;